import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

interface Props {
  size?: number;
  className?: string;
}

const UnresolvedIssueExistsIcon = ({ size = 24, className }: ClassAttributes<SVGElement> & Props) => (
  <Root
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    version="1.1"
    width={size}
    height={size}
    className={className}
  >
    <path d="M417.57,83.39c-40.51-34.26-98.42-54.27-169.23-54.25-67.2,0-124.58,19-165.61,52.76A177.45,177.45,0,0,0,34.8,142.81a179.45,179.45,0,0,0-17,77.42c0,33.61,7,64.66,21.24,91.75,13.54,25.9,33.69,47.91,59.35,65.13-6.07,25.54-14.6,62-14.6,62.05a20.94,20.94,0,0,0-.57,5.08A22.32,22.32,0,0,0,92,462l0,0h0a22.46,22.46,0,0,0,13.56,4.57,22.2,22.2,0,0,0,10.55-2.65l.33-.17.32-.19,11.62-6.89c10.54-6.23,26.59-15.72,40.91-24.16,7.16-4.21,13.89-8.16,19.25-11.29s9.47-5.52,11-6.36l.06,0,.11-.06c20-11.32,35.86-13.22,48.64-13.29,53-.07,109.49-10.35,154.58-38.5,22.5-14.09,42.07-32.89,55.83-57s21.58-53.16,21.57-86.86C480.42,166.14,458.11,117.57,417.57,83.39Zm11,205.32a123.3,123.3,0,0,1-30.92,35.49c-18.77,14.84-42.34,25.55-68.18,32.46s-53.89,10-81.12,10c-16.72-.07-40.08,3.08-65.72,17.78h0c-2.84,1.58-9.16,5.26-17.48,10.13-11.95,7-27.66,16.28-40.78,24,3.2-13.63,6.92-29.42,9.69-41v0a27.77,27.77,0,0,0,.79-6.42,21.6,21.6,0,0,0-7.68-16.83,28.87,28.87,0,0,0-5.36-3.52l-1.06-.54-.12-.07c-22.71-14.63-39.43-32.81-50.75-54.37s-17.26-46.77-17.26-75.59c0-22.95,4.78-43.84,13.63-62.5,13.28-27.95,35.83-51.13,66.65-67.66s69.92-26.14,115.45-26.14C312.73,64,362.1,82,395.09,110s50.31,65.76,50.43,109.18C445.48,247.6,439.13,270.19,428.56,288.71Z" />
    <path d="M139.81,194.71a26.63,26.63,0,1,0,26.63,26.63A26.62,26.62,0,0,0,139.81,194.71Z" />
    <path d="M243.67,194.71a26.63,26.63,0,1,0,26.63,26.63A26.63,26.63,0,0,0,243.67,194.71Z" />
    <path d="M347.53,194.71a26.63,26.63,0,1,0,26.63,26.63A26.64,26.64,0,0,0,347.53,194.71Z" />
  </Root>
);

const Root = styled('svg')({ fill: 'currentColor' });

export default UnresolvedIssueExistsIcon;
